// extracted by mini-css-extract-plugin
export default {"root":"ProductCard_root__Xa5zO","image":"ProductCard_image__Vo1nS"};